/**
 * Represents a single region the user is auditing.
 */

export class Region {
  #properties = {
    name: null,
    regionId: null,
  };

  /**
   * @param {object} parameters - May contain regionId and name.
   */
  constructor(parameters) {
    if ('regionId' in parameters) {
      this.setProperty('regionId', parameters.regionId);
      this.regionId = parameters.regionId; // Exposed publicly for debugging in the console.
    }
    if ('name' in parameters) this.setProperty('name', parameters.name);
  }

  /**
   * @param {string} key
   * @returns {*} The property value, or null if not present.
   */
  getProperty(key) {
    return key in this.#properties ? this.#properties[key] : null;
  }

  /**
   * @param {string} key
   * @param {*} value
   * @returns {Region} this, for chaining.
   */
  setProperty(key, value) {
    this.#properties[key] = value;
    return this;
  }

  /**
   * @returns {*} Region id of this region.
   */
  getRegionId() {
    return this.getProperty('regionId');
  }
}
